export const SITE_URL = 'https://margarita.akhmejanova.com';
export const DEFAULT_LANGUAGE = 'en';
export const RUSSIAN_PREFIX = '/ru';

export const getLanguageFromPathname = (pathname) => {
  return pathname === RUSSIAN_PREFIX || pathname.startsWith(`${RUSSIAN_PREFIX}/`)
    ? 'ru'
    : DEFAULT_LANGUAGE;
};

export const stripLanguagePrefix = (pathname) => {
  if (pathname === RUSSIAN_PREFIX) {
    return '/';
  }

  if (pathname.startsWith(`${RUSSIAN_PREFIX}/`)) {
    return pathname.slice(RUSSIAN_PREFIX.length) || '/';
  }

  return pathname || '/';
};

export const withLanguagePrefix = (pathname, language) => {
  const path = stripLanguagePrefix(pathname);

  if (language === 'ru') {
    return path === '/' ? RUSSIAN_PREFIX : `${RUSSIAN_PREFIX}${path}`;
  }

  return path;
};

export const buildAbsoluteUrl = (pathname, language) => {
  return `${SITE_URL}${withLanguagePrefix(pathname, language)}`;
};
